<template>
  <div style="height:100%">
    <SplitContainer3 style="height:100%" :layout="12">
      <template #main>
        <el-card class="box-card" style="height: 100%" shadow="always">
          <div>
            <i class="iconfont icon-tree" style="font-size: 16px"><span class="ml-1"
                style="font-size: 12px"><strong>角色结构树</strong></span></i>
          </div>
          <div class="ml-2">
            <el-input placeholder="输入关键字进行过滤" v-model="filterText" class="mt-2" style="width: 200px">
            </el-input>
          </div>

          <div class="custom-tree-container" :class="treeTheme">
            <el-tree :data="rootRoleData" :props="defaultProps" :load="loadNode" @node-click="handleClick" lazy
              class="mt-2 filter-tree" :filter-node-method="filterNode" ref="roleTree" :default-expanded-keys="openNode"
              node-key="node_key"></el-tree>
          </div>
        </el-card>
      </template>
      <template #top>
        <TableMain :show_query_container="false" :show_date_picker="false" :show_toolbar="false" ref="roleTableRef"
          :fields="role_fields" :table_height_adjust="9" :title="table_title.title2"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_check="true"
          tableref="e8c80bfd01ef4b5999ea816220b76d26">
          <template #operation>
            <el-button type="success" size="mini" plain class="iconfont icon-save" @click="saveRoleChildren">&nbsp;保
              存</el-button>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="privilegeTableRef" :fields="privilege_fields" :show_query_container="false"
          :show_toolbar="false" :title="table_title.title3" :date_picker_label="date_picker_label"
          :table_height_adjust="2" :check_state="true" :show_check="true" tableref="9a14bd82f1344600b58e26be89a6fb95">
          <!-- <template #operation>
            <el-button
              type="success"
              size="mini"
              plain
              class="iconfont icon-save"
              @click="saveRoleOwnPrivilege"
              >&nbsp;保 存</el-button
            >
          </template> -->
        </TableMain>
      </template>
    </SplitContainer3>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="dataForm.name"></el-input>
          </el-form-item>
          <el-form-item label="活动区域" prop="region">
            <el-select v-model="dataForm.region" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动时间" required>
            <el-col :span="11">
              <el-form-item prop="date1">
                <el-date-picker type="date" placeholder="选择日期" v-model="dataForm.date1"
                  style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-time-picker placeholder="选择时间" v-model="dataForm.date2" style="width: 100%"></el-time-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="即时配送" prop="delivery">
            <el-switch v-model="dataForm.delivery"></el-switch>
          </el-form-item>
          <el-form-item label="活动性质" prop="type">
            <el-checkbox-group v-model="dataForm.type">
              <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
              <el-checkbox label="地推活动" name="type"></el-checkbox>
              <el-checkbox label="线下主题活动" name="type"></el-checkbox>
              <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="特殊资源" prop="resource">
            <el-radio-group v-model="dataForm.resource">
              <el-radio label="线上品牌商赞助"></el-radio>
              <el-radio label="线下场地免费"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动形式" prop="desc">
            <el-input type="textarea" v-model="dataForm.desc"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as RolePropertyManageController from "../../controllers/system/RolePropertyManageController"
import SplitContainer3 from "../components/container/SplitContainer3"

export default {
  name: "PropertyManage",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer3,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "角色信息列表",
        title2: "角色信息列表",
        title3: "权限信息列表",
      },
      modal_title: "create_role_privilege",
      role_fields: RolePropertyManageController.role_fields,
      privilege_fields: RolePropertyManageController.privilege_fields,
      dataForm: _.cloneDeep(RolePropertyManageController.dataForm),
      rules: RolePropertyManageController.rules,
      methods: RolePropertyManageController.methods,
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf",
      },
      rootRoleData: [],
      roleHasData: [],
      roleNewData: [],
      childHasData: [],
      childNewData: [],
      selectedItem: null,
      filterText: "",
      treeTheme: "treeTheme",
      openNode: [],
      sys_role: [],
      nodeSelectItems: [],
    }
  },
  watch: {
    filterText(val) {
      this.$refs.roleTree.filter(val)
    },
  },
  created() {
    this.GetPrivilige()
    this.getRoleList()
    // let theme = localStorage.getItem("theme");
    // if (theme) {
    //   if (theme == "yellow") {
    //     this.treeTheme = "treeTheme";
    //   }
    //   if (theme == "blue") {
    //     this.treeTheme = "treeTheme1";
    //   }
    //   if (theme == "green") {
    //     this.treeTheme = "treeTheme2";
    //   }
    //   if (theme == "gray") {
    //     this.treeTheme = "treeTheme3";
    //   }
    // }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    //获取所有role
    async getRoleList() {
      let _dt = await this.methods.GetRoleList()
      //过滤is_sys
      this.sys_role = _.filter(_dt, { is_sys: true })
      _dt = _.filter(_dt, { is_sys: false })

      this.$refs.roleTableRef.SetData(_dt)
      await this.getRootRoleList()
    },
    //保存角色子节点
    async saveRoleChildren() {
      let _this = this
      if (this.selectedItem == null) {
        this.msgToasts("请选择角色后再进行保存！", "warning")
        return
      }
      this.childNewData = JSON.parse(
        JSON.stringify(
          _.filter(_this.$refs.roleTableRef.my_data, (d) => d._selected)
        )
      )
      let newData = JSON.parse(JSON.stringify(this.childNewData))
      let hasData = JSON.parse(JSON.stringify(this.childHasData))
      let _add = [],
        _addData = [],
        _del = [],
        _delData = []
      for (var i in newData) {
        if (
          _.findIndex(hasData, {
            id: newData[i].id,
          }) < 0
        ) {
          _add.push({ id: newData[i].id, name: newData[i].name })
          _addData.push(newData[i])
        }
      }
      //如果newData中不包含hasData的权限即为删除
      for (var i in hasData) {
        if (
          _.findIndex(newData, {
            id: hasData[i].id,
          }) < 0
        ) {
          _del.push({ id: hasData[i].id })
          _delData.push(hasData[i])
        }
      }
      if (this.childHasData.length == 0 && this.childNewData.length == 0) {
        this.msgToasts("没有要保存的项目", "info")
        return
      }
      let _b = await this.methods.AddOrDeletedRoleChildren(
        _this.selectedItem.roleId,
        _this.childHasData,
        _this.childNewData
      )
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        if (!_.isEmpty(_add)) {
          this.appendChildren(_add, _this.selectedItem.roleId)
        }
        if (!_.isEmpty(_del)) {
          this.deletedChildren(_del, _this.selectedItem.roleId)
        }
        this.changeChildrenHasData(_addData, _delData)
        //更改childHasData中的数据
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
      //this.getRootRoleList();
    },
    //改变数据源的data
    changeChildrenHasData(add, del) {
      for (var i in add) {
        this.childHasData.push(add[i])
      }
      for (var i in del) {
        let index = _.findIndex(this.childHasData, { id: del[i].id })
        if (index > -1) {
          this.childHasData.splice(index, 1)
        }
      }
      //改变根目录
      this.changeRoot()
    },
    //改变根目录
    async changeRoot() {
      let _this = this
      let rootRoleData = []
      let data = await this.methods.getRootRoleList()
      //过滤sys_role
      for (var i in data) {
        if (_.findIndex(_this.sys_role, { id: data[i].id }) < 0) {
          rootRoleData.push({
            roleId: data[i].id,
            label: data[i].name,
          })
        }
      }
      let newData = _.xorBy(this.rootRoleData, rootRoleData, "roleId")
      for (var i in newData) {
        let index = _.findIndex(this.rootRoleData, {
          roleId: newData[i].roleId,
        })
        //新增
        if (index > -1) {
          this.$refs.roleTree.remove(newData[i].roleId)
        } else {
          this.rootRoleData.push({
            roleId: newData[i].roleId,
            label: newData[i].label,
            node_key: newData[i].roleId,
          })
        }
      }
    },
    // 新增子节点
    appendChildren(data, roleId) {
      let _this = this
      let nodes = _.filter(this.nodeSelectItems, function (o) {
        return o.data.roleId == roleId
      })
      for (var j in nodes) {
        for (var i in data) {
          const newChild = {
            roleId: data[i].id,
            label: data[i].name,
            children: [],
          }
          if (!nodes[j].data.children) {
            _this.$set(nodes[j].data, "children", [])
          }
          if (
            _.findIndex(nodes[j].data.children, { roleId: newChild.roleId }) < 0
          ) {
            nodes[j].data.children.push(newChild)
          }
        }
      }
    },
    // 删除子节点
    deletedChildren(data, roleId) {
      let nodes = this.nodeSelectItems
      let _data = _.filter(nodes, function (o) {
        return o.data.roleId == roleId
      })
      for (var i in _data) {
        for (var j in data) {
          const children = _data[i].childNodes
          const index = _.findIndex(children, function (o) {
            return o.data.roleId == data[j].id
          })
          if (index > -1) {
            children.splice(index, 1)
          }
          //_data[i].data.children = [];
          //this.$delete(_data[i].data, "children");
          //this.$delete(_data[i].data, "children");
          _.unset(_data[i].data, "children")
        }
      }
    },
    //点击node
    async handleClick(data, node) {
      if (_.findIndex(this.nodeSelectItems, { id: node.id }) < 0) {
        this.nodeSelectItems.push(node)
      }
      let _this = this
      let role = await this.methods.getRootRoleChildren(data.roleId)
      //过滤role
      role = _.filter(role, { parentId: data.roleId })
      let privilege = await this.methods.GetRoleAllPrivilege(data.roleId)
      this.selectedItem = data
      this.roleHasData = privilege

      //设置privilege选中项
      _this.$refs.privilegeTableRef.setSelect(privilege)
      //设置role的选中项(非id不通用,无法调取tableMain中的Setselect方法)
      if (this.$refs.roleTableRef.only_selected) {
        _this.$refs.roleTableRef.on_only_selected()
      }
      _this.$refs.roleTableRef.UnSelectAll()
      _.each(role, (t) => {
        let _m = _.find(_this.$refs.roleTableRef.my_data, { id: t.roleId })
        if (_m) {
          _this.$set(_m, "_selected", true)
          _this.$refs.roleTableRef.updateRowBackgroundColor(_m)
        }
      })
      _this.$refs.roleTableRef.updateSelectState()
      this.childHasData = JSON.parse(
        JSON.stringify(
          _.filter(_this.$refs.roleTableRef.my_data, (d) => d._selected)
        )
      )
    },

    //保存角色ownPrivilege
    async saveRoleOwnPrivilege() {
      let _this = this
      if (this.selectedItem == null) {
        this.msgToasts("请选择角色后再进行保存！", "warning")
        return
      }
      this.roleNewData = _.filter(
        _this.$refs.privilegeTableRef.my_data,
        (d) => d._selected
      )

      let _b = await this.methods.AddORDeleteRoleOwnPrivileges(
        _this.selectedItem.roleId,
        _this.roleHasData,
        _this.roleNewData
      )
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },
    //获取权限
    async GetPrivilige() {
      let _dt = await this.methods.GetPrivilege()
      this.$refs.privilegeTableRef.SetData(_dt)
    },
    //懒加载节点
    async loadNode(node, resolve) {
      let _this = this
      if (node.level == 0) {
        return
      }

      let role = await this.methods.getRootRoleChildren(node.data.roleId)
      let resolveData = []
      role = _.filter(role, { parentId: node.data.roleId })
      let maxlevel = _.maxBy(role, "lvl")
      for (var i in role) {
        //如果parent是当前选中行的子节点则push进当前data
        if (
          role[i].parentId == node.data.roleId &&
          _.findIndex(_this.sys_role, { id: role[i].roleId }) < 0
        ) {
          resolveData.push({
            roleId: role[i].roleId,
            label: role[i].name,
            leaf: role[i].lvl == maxlevel ? true : false,
          })
        }
      }
      resolve(resolveData)
    },
    //获取根树
    async getRootRoleList() {
      let _this = this
      let rootRoleData = []
      let data = await this.methods.getRootRoleList()
      //过滤sys_role
      for (var i in data) {
        if (_.findIndex(_this.sys_role, { id: data[i].id }) < 0) {
          rootRoleData.push({
            roleId: data[i].id,
            label: data[i].name,
            node_key: data[i].id,
          })
        }
      }
      this.rootRoleData = rootRoleData
    },
    //#region 查询
    async on_query(set_data) {
      ///模拟数据
      let _dt = []
      for (var i = 1; i <= 30000; i++) {
        _dt.push({
          num: i,
          name: "ABC" + i,
          short_name: "abc" + i,
          contact: "aa",
          tele: "123456789",
          salesman_name: "bb",
          customer_service_name: "ddd",
          address: "ccc",
          is_valid: true,
          is_approved: true,
        })
      }
      set_data(_.orderBy(_dt, ["seq"], ["asc"]))

      ///配置api code
      // SOApprovedController.biz_data.content_type = this.tableName;
      // console.log(SOApprovedController.biz_data);
      // await SOApprovedController.biz_data
      //   .selectAction({ params: {}, fields: this.fields })
      //   .run()
      //   .then((data) => {
      //     let _dt = data[0].result.data.ActionResult.Result.Data;
      //     set_data(_.orderBy(_dt[0], ["seq"], ["asc"]));
      //   });

      ///批量
      // let batch_actions = []
      // for (let i = 0; i < 5; i++) {
      //   batch_actions.push(SOApprovedController.biz_data.selectAction({ params: {}, fields: ["id", "idx", "name", "code", "description"] }).action())
      // }
      // await api.query_batch({ actions: batch_actions }).then((data) => {
      // })
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "create_role_privilege"
          break
        case "edit":
          title = "edite_role_privilege"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
      this.dataForm = _.cloneDeep(RolePropertyManageController.dataForm)
    },
    ///新增修改
    saveData(cb) {
      let _this = this
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          ///保存数据

          ///成功
          cb(true, true)
          ///失败
          // cb(true, false,"错误：")
        } else {
          cb(false)
          return false
        }
      })
    },
    //#endregion

    current_changed(old, current) {

      this.$emit("current_changed", old, current)
    },
  },
}
</script>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.custom-tree-container {
  height: 100%;
  overflow-y: auto;
}
</style>
